"use client";

import React, { useState } from "react";
import Link from "next/link";

export default function Navbar({ lang = 'vn', setLang }: { lang?: 'vn' | 'en', setLang?: (lang: 'vn' | 'en') => void }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <div className="navigation w-nav" data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" data-wf--navigation--variant="base" role="banner">
       <div className="nav-container">
        <div className="nav-left_flex">
         <a aria-current="page" className="brand-5 w-nav-brand w--current" href="/" style={{ flexShrink: 0, minWidth: '120px' }}>
          <img alt="KeenEye Logo" loading="eager" src="/assets/img/keeneye-horizontal-white.png" style={{ height: "32px", width: "auto", objectFit: "contain", display: "block", flexShrink: 0 }}/>
         </a>
         {/* Mobile Menu Overlay */}
         <div className={`w-nav-overlay ${isMobileMenuOpen ? 'w--open' : ''}`} style={{ display: isMobileMenuOpen ? 'block' : 'none' }}>
           <nav className={`navlink-wrapper vert-mobile-landscale w-nav-menu ${isMobileMenuOpen ? 'w--open' : ''}`} role="navigation">
            <a className="navlink w-nav-link" href="/ai-security-guard">
             {lang === 'vn' ? 'Bảo vệ AI' : 'AI Security Guard'}
            </a>
            <a className="navlink w-nav-link" href="/ai-operations-assistant">
             {lang === 'vn' ? 'Trợ lý Vận hành AI' : 'AI Operations Assistant'}
            </a>
            <div className={`dropdown-5 w-dropdown ${isDropdownOpen ? 'w--open' : ''}`} 
                 data-delay="0" data-hover="false" 
                 onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                 onMouseEnter={() => setIsDropdownOpen(true)}
                 onMouseLeave={() => setIsDropdownOpen(false)}>
             <div className="navlink padding w-dropdown-toggle">
              <div className={`icon-7 w-icon-dropdown-toggle ${isDropdownOpen ? 'w--open' : ''}`}>
              </div>
              <div>
               {lang === 'vn' ? 'Tài nguyên' : 'Learn'}
              </div>
             </div>
             <nav className={`dropdown-list-6 w-dropdown-list ${isDropdownOpen ? 'w--open' : ''}`}>
              <a className="navlink w-dropdown-link" href="/blog">
               Blog
              </a>
              <a className="navlink w-dropdown-link" href="/customer-stories">
               {lang === 'vn' ? 'Câu chuyện Khách hàng' : 'Customer Stories'}
              </a>
              <a className="navlink w-dropdown-link" href="/careers">
               {lang === 'vn' ? 'Tuyển dụng' : 'Careers'}
              </a>
              <a className="nav-letter-link w-inline-block" href="/newsletter">
               <img alt="" className="image-nav-letter-link" loading="eager" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/6a01d12afdcd99beb64acfa3_TheEdge-Dark%20(1).svg"/>
               <div className="text-nav-letter-link">
                {lang === 'vn' ? 'Bản tin' : 'Newsletter'}
               </div>
              </a>
             </nav>
            </div>
             <div className="nav-button-wapper desktop-hide">
              <a className="button-primary mb-hide w-button" href="/dashboard">
               {lang === 'vn' ? 'Bảng điều khiển' : 'Dashboard'}
              </a>
              <a className="button-secondary mb-hide w-button" href="https://try.keeneyeai.site/contact" target="_blank" rel="noreferrer">
               {lang === 'vn' ? 'Yêu cầu Demo' : 'Request a Demo'}
              </a>
             </div>
             <a className="button-secondary mb-hide mw-mobile w-button" href="https://try.keeneyeai.site/contact">
              {lang === 'vn' ? 'Yêu cầu Demo' : 'Request a Demo'}
             </a>
             <a className="button-primary has-outline mb-hide mw-mobile w-button" href="https://keeneyeai.site/become-a-partner">
              {lang === 'vn' ? 'Trở thành Đối tác' : 'Become a Partner'}
             </a>
             <a className="button-primary mb-wd mw-mobile transparent-bg hide-desktop w-button" href="https://dashboard.keeneyeai.site" target="_blank" rel="noreferrer">
              {lang === 'vn' ? 'Đăng nhập' : 'Login'}
             </a>
           </nav>
         </div>

         {/* Desktop Menu */}
         <nav className="navlink-wrapper vert-mobile-landscale w-nav-menu" role="navigation" style={{ display: isMobileMenuOpen ? 'none' : '' }}>
          <a className="navlink w-nav-link" href="/ai-security-guard">
           {lang === 'vn' ? 'Bảo vệ AI' : 'AI Security Guard'}
          </a>
          <a className="navlink w-nav-link" href="/ai-operations-assistant">
           {lang === 'vn' ? 'Trợ lý Vận hành AI' : 'AI Operations Assistant'}
          </a>
          <div className={`dropdown-5 w-dropdown ${isDropdownOpen ? 'w--open' : ''}`} 
               data-delay="0" data-hover="false"
               onMouseEnter={() => setIsDropdownOpen(true)}
               onMouseLeave={() => setIsDropdownOpen(false)}>
           <div className="navlink padding w-dropdown-toggle">
            <div className={`icon-7 w-icon-dropdown-toggle ${isDropdownOpen ? 'w--open' : ''}`}>
            </div>
            <div>
             {lang === 'vn' ? 'Tài nguyên' : 'Learn'}
            </div>
           </div>
           <nav className={`dropdown-list-6 w-dropdown-list ${isDropdownOpen ? 'w--open' : ''}`}>
            <a className="navlink w-dropdown-link" href="/blog">
             Blog
            </a>
            <a className="navlink w-dropdown-link" href="/customer-stories">
             {lang === 'vn' ? 'Câu chuyện Khách hàng' : 'Customer Stories'}
            </a>
            <a className="navlink w-dropdown-link" href="/careers">
             {lang === 'vn' ? 'Tuyển dụng' : 'Careers'}
            </a>
            <a className="nav-letter-link w-inline-block" href="/newsletter">
             <img alt="" className="image-nav-letter-link" loading="eager" src="https://cdn.prod.website-files.com/5fe2250e2f83cc02cbfefbcf/6a01d12afdcd99beb64acfa3_TheEdge-Dark%20(1).svg"/>
             <div className="text-nav-letter-link">
              {lang === 'vn' ? 'Bản tin' : 'Newsletter'}
             </div>
            </a>
           </nav>
          </div>
          <div className="nav-button-wapper desktop-hide">
            <a className="button-primary mb-hide w-button" href="/dashboard">
             {lang === 'vn' ? 'Bảng điều khiển' : 'Dashboard'}
            </a>
            <a className="button-secondary mb-hide w-button" href="https://try.keeneyeai.site/contact" target="_blank" rel="noreferrer">
             {lang === 'vn' ? 'Yêu cầu Demo' : 'Request a Demo'}
            </a>
           </div>
           <a className="button-secondary mb-hide mw-mobile w-button" href="https://try.keeneyeai.site/contact">
            {lang === 'vn' ? 'Yêu cầu Demo' : 'Request a Demo'}
           </a>
           <a className="button-primary has-outline mb-hide mw-mobile w-button" href="https://keeneyeai.site/become-a-partner">
            {lang === 'vn' ? 'Trở thành Đối tác' : 'Become a Partner'}
           </a>
           <a className="button-primary mb-wd mw-mobile transparent-bg hide-desktop w-button" href="/dashboard">
            {lang === 'vn' ? 'Bảng điều khiển' : 'Dashboard'}
           </a>
         </nav>
        </div>
        <div className="nav-button-wapper vert-center">
          <div className="lang-switcher-container">
            <button onClick={() => setLang?.('vn')} className={`lang-switcher-btn ${lang === 'vn' ? 'active' : ''}`}>VN</button>
            <button onClick={() => setLang?.('en')} className={`lang-switcher-btn ${lang === 'en' ? 'active' : ''}`}>EN</button>
          </div>
          <a className="text-color-white hide-landscape-mobile" href="/dashboard" style={{ whiteSpace: 'nowrap', margin: '0 12px', fontSize: '14px', fontWeight: '600', flexShrink: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
           {lang === 'vn' ? 'Bảng điều khiển' : 'Dashboard'}
          </a>
          <a className="button-secondary mb-hide w-button" href="https://try.keeneyeai.site/contact" style={{ flexShrink: 1, padding: lang === 'vn' ? '6px 10px' : '', fontSize: lang === 'vn' ? '13px' : '', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
           {lang === 'vn' ? 'Yêu cầu Demo' : 'Book a Demo'}
          </a>
         <a className="button-primary has-outline mb-hide w-button" href="/become-a-partner" style={{ flexShrink: 1, padding: lang === 'vn' ? '6px 10px' : '', fontSize: lang === 'vn' ? '13px' : '', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {lang === 'vn' ? 'Trở thành Đối tác' : 'Become a Partner'}
         </a>
         <div className={`menu-button-5 w-nav-button ${isMobileMenuOpen ? 'w--open' : ''}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <div className="w-icon-nav-menu">
          </div>
         </div>
        </div>
       </div>
      </div>
    </>
  );
}
